import mutations from './mutations';
import actions from './actions';
import initialState from './initialState';

export default {
  mutations,
  actions,
  state: initialState,
};
